module.exports = __webpack_public_path__ + "img/incubator-1.993445ba.jpg";